import { ModalFuncProps } from 'antd';

const dataTestIdFromTitle = (title: ModalFuncProps['title'], prefix: string = 'modal') => {
  return typeof title === 'string' ? `${title.toLowerCase().replace(/\s+/g, '-')}-${prefix}` : prefix;
};

export default dataTestIdFromTitle;
